import { render, staticRenderFns } from "./ChangLianProductList.vue?vue&type=template&id=5d41da9d&scoped=true"
import script from "./ChangLianProductList.vue?vue&type=script&lang=js"
export * from "./ChangLianProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d41da9d",
  null
  
)

export default component.exports